import { Controller } from "@hotwired/stimulus"

// A clock dial (dials/_clock_face). The server renders the time once; this
// keeps it current — every 15 seconds, so a minute never lags by more than
// that — and flips the tile between day and night as the city's hours do.
export default class extends Controller {
    static targets = ["time", "period"]
    static values = { zone: String }

    connect() {
        this.tick()
        this.timer = setInterval(() => this.tick(), 15000)
    }

    disconnect() {
        clearInterval(this.timer)
    }

    tick() {
        let parts
        try {
            parts = new Intl.DateTimeFormat("en-US", { timeZone: this.zoneValue, hour: "numeric", minute: "2-digit", hour12: true })
                .formatToParts(new Date())
        } catch {
            return
        }
        const get = (type) => parts.find((part) => part.type === type)?.value
        const hour = Number(get("hour"))
        const period = get("dayPeriod")
        if (this.hasTimeTarget) this.timeTarget.textContent = `${hour}:${get("minute")}`
        if (this.hasPeriodTarget && period) this.periodTarget.textContent = period
        const hour24 = (hour % 12) + (period === "PM" ? 12 : 0)
        const day = hour24 >= 6 && hour24 < 18
        this.element.classList.toggle("is-day", day)
        this.element.classList.toggle("is-night", !day)
    }
}
